import { useMutation, useQuery } from "@tanstack/react-query";
import { authClient } from "../lib/auth-client";
import { trpc } from "../lib/trpc";

// @ts-ignore - better-auth types are complex
const { signIn, signUp, useSession, forgetPassword, resetPassword } =
  authClient;

export { authClient, signIn, signUp, useSession, forgetPassword, resetPassword };

// --- User Groups Hook ---
// Only fetch groups when there is a valid session (enabled = true)
export const useUserGroups = (enabled: boolean = false) =>
  useQuery({
    queryKey: ["groups", "list"],
    queryFn: () => trpc.group.list.query({}),
    enabled,
  });

// Forget password hook
export const useForgetPassword = (
  onSuccess: (data: any) => void,
  onError: (error: unknown) => void
) =>
  useMutation({
    mutationKey: ["forgetPassword"],
    mutationFn: async (params: { email: string }) => {
      // @ts-ignore - better-auth emailOTP types
      const { data, error } = await authClient.forgetPassword({
        email: params.email,
        redirectTo: "/reset-password",
      });
      if (error) throw error;
      return data;
    },
    onSuccess,
    onError,
  });

const signoutRequest = async () => {
  await authClient.signOut();
  return true;
};

export const useSignout = (
  onSuccess: () => void,
  onError: (error: unknown) => void
) =>
  useMutation({
    mutationKey: ["signout"],
    mutationFn: signoutRequest,
    onSuccess,
    onError,
  });